import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  SxProps,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { SuccessAlertContext } from "App";
import { removeEmptyValues } from "../utils/common";
import downloadOrderSupplierCsv from "../api/downloadOrderSupplierCsv";

type Props = {
  open: boolean;
  onClose: Function;
  dlMode: 0 | 1 | 2 | 9;
};

type RadioIndex = 0 | 1;

const radioOptions = [
  "未ダウンロードの受注のみ",
  "未出荷全ての受注を",
  // '未ダウンロード + ダウンロード済みの受注',
  // '未ダウンロード + ダウンロード済みの受注（期間指定）',
];

const styles: { [key: string]: SxProps } = {
  searchRowBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  searchRowBox3: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    width: "464px",
  },
};

/**
 * 出荷情報設定モーダル
 * @param root0 コンポーネントのプロップス
 */
export default function SelectDownloadMode({ open, onClose, dlMode }: Props) {
  // const [dlMode, setDlMode] = useState<RadioIndex>(0);
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState("");
  // const [selectedIndex, setSelectedIndex] = useState(0);
  // const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
  //   const index = parseInt(e.target.value, 10) as RadioIndex;
  //   setSelectedIndex(index);
  //   setDlMode(index);
  // };
  const [isDownloading, setIsDownloading] = useState(false);
  const { showAlert } = useContext(SuccessAlertContext);

  const canDownload = () => !(dlMode === 2 || dlMode === 9);
  const content = () => {
    if (!canDownload()) {
      return '未ダウンロード、未出荷全てのみダウンロード可能です。'
    }
    return `${radioOptions[dlMode]}ダウンロードします。`
  }

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      PaperProps={{
        sx: {
          minWidth: 550,
          // width: '80vw',
          maxWidth: 1200,
        },
      }}
    >
      <DialogTitle>受注CSVダウンロード</DialogTitle>
      <DialogContent>
        <Grid container direction="column" spacing={2}>
          {/* タイトル */}
          <Grid item>
            <Typography ml={2} color="rgb(50,50,50)">
              {content()}
            </Typography>
          </Grid>
          {/* フォーム */}
          <Grid item container justifyContent="center">
            <Grid item textAlign="center" justifyItems="center" my={1} mr={0}>

              {/* <FormControl component="fieldset"> */}
                {/* <FormLabel component="legend">ダウンロードしたい未発送の受注を選択してください。</FormLabel> */}
                {/* <RadioGroup value={String(selectedIndex)} onChange={handleChange}>
                  {radioOptions.map((o, i) => (
                    <FormControlLabel
                      // eslint-disable-next-line react/no-array-index-key
                      key={i}
                      value={String(i)}
                      control={<Radio />}
                      label={o}
                    />
                  ))}
                </RadioGroup> */}
              {/* </FormControl> */}
              {/* <Box sx={styles.searchRowBox3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="注文日（開始）"
                    format="YYYY/MM/DD"
                    maxDate={endDate ? dayjs(endDate) : dayjs().add(1,'day')}
                    value={startDate ? dayjs(startDate, "YYYY/MM/DD") : null}
                    onChange={(val) => setStartDate(val ? val.format("YYYY/MM/DD") : "")}
                    slotProps={{ textField: { size: "small" } }}
                    sx={{
                      width: "calc(50% - 16px)",
                      margin: "8px",
                    }}
                    disabled={selectedIndex !== 3}
                  />
                </LocalizationProvider>
                <Box width="16px" textAlign="center" lineHeight="54px">
                  ～
                </Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="注文日（終了）"
                    format="YYYY/MM/DD"
                    maxDate={dayjs().add(1,'day')}
                    minDate={startDate ? dayjs(startDate) : undefined}
                    value={endDate ? dayjs(endDate, "YYYY/MM/DD") : null}
                    onChange={(val) => setEndDate(val ? val.format("YYYY/MM/DD") : "")}
                    slotProps={{ textField: { size: "small" } }}
                    sx={{
                      width: "calc(50% - 16px)",
                      margin: "8px",
                    }}
                    disabled={selectedIndex !== 3}
                  />
                </LocalizationProvider>
              </Box> */}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="custom-outlined" onClick={() => onClose()}>
          キャンセル
        </Button>
        <Button
          variant="contained"
          onClick={async () => {
            setIsDownloading(true);
            try {
              await downloadOrderSupplierCsv(removeEmptyValues({
                dl_mode: dlMode === 1 ? 1 : 0,
                // dl_mode: dlMode === 1 ? undefined : 0,
                // from: startDate,
                // to: endDate
              }));
              onClose();
            } catch (err) {
              console.error(err);
              showAlert('ダウンロードに失敗しました。', 'error');
            } finally {
              setIsDownloading(false);
            }
          }}
          disabled={!canDownload() || isDownloading}
        >
          CSVダウンロード
        </Button>
      </DialogActions>
    </Dialog>
  );
}
